module.exports = __webpack_public_path__ + "static/media/MIGR.ca659dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MIGR.jpg
// module id = 1768
// module chunks = 1